import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_Forms_BEFormRequestModel,
  ResponseModels_Forms_BugReportInfoResponseModel,
  ResponseModels_Forms_ImprovementFormInfoResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type PostEloquaForm = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  formName: string;
  requestBody: RequestModels_Forms_BEFormRequestModel;
};
/**
 * Post a form by name
 *
 * @returns any Success
 */
export function postEloquaForm(
  { businessUnit, label, customerId, formName, requestBody }: PostEloquaForm,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/forms/${formName}`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetReportABugFormCategories = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
};
/**
 * Get the categories used for bugreport form
 *
 * @returns ResponseModels_Forms_BugReportInfoResponseModel Success
 */
export function getReportABugFormCategories(
  { businessUnit, label, customerId }: GetReportABugFormCategories,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Forms_BugReportInfoResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/forms/bugreport/info`,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetImprovementFormInfo = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
};
/**
 * Get the info used for the improvement form
 *
 * @returns ResponseModels_Forms_ImprovementFormInfoResponseModel Success
 */
export function getImprovementFormInfo(
  { businessUnit, label, customerId }: GetImprovementFormInfo,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Forms_ImprovementFormInfoResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/forms/improvement/info`,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
